
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/the-heritage-story",
      function () {
        return require("private-next-pages/en/the-heritage-story.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/the-heritage-story"])
      });
    }
  